var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-time-here-wrapper"},[_c('div',{staticClass:"text-header-1 mb-8px"},[_vm._v("First time here? 🎉")]),_c('div',{staticClass:"text-body-4"},[_vm._v(" We'll almost ready to get you booked, just a few quick steps left. ")])])
}]

export { render, staticRenderFns }